export default __webpack_public_path__ + "static/media/gusano.6c169a04.png";